<script lang="ts" setup>
import {
  PieChart01,
  TypeSquare,
  Phone,
  Microphone01,
  Image03,
  PieChart02,
  Trash01,
  Edit02,
  Clock,
  PhoneHangUp,
} from "utruckin-icons";

import CustomPanel from "@/components/custom/CustomPanel.vue";
import {useStatsStore} from "@/features/stats/stats.store";
import {ICountFilter, IFilter} from "@/types/main";
import {computed, onMounted, ref, watch} from "vue";
import {useErrorStore} from "@/features/errors/errors.store";

interface IProps {
  filter: IFilter;
}

const store = useStatsStore();
const errorStore = useErrorStore();

const loading = ref<boolean>(false);
const data = ref()


const props = withDefaults(defineProps<IProps>(), {});

const countFilter = computed(() => {
  if (props.filter) {
    return {
      account_id: props.filter.account,
      time_from: props.filter.time_from,
      time_to: props.filter.time_to,
      date_from: props.filter.date_from,
      date_to: props.filter.date_to,
      shift_id: props.filter.shift,
    }
  }
})

const getInfo = async () => {
  data.value = await store.getStats(countFilter.value as ICountFilter, loading);
}

const info = computed(() => {
  const source = data.value

  return {
    errors: {
      total: source?.errors?.total ?? 0,
      reply_time: source?.errors?.reply_time_exceed ?? 0,
      deleted: source?.errors?.deleted ?? 0,
      edited: source?.errors?.edited ?? 0,
      unanswered:
          (source?.errors?.declined_calls ?? 0) +
          (source?.errors?.missed_calls ?? 0),
    }
  };
});

watch(
    () => JSON.stringify(countFilter.value),
    () => {
      getInfo()
    },
    {immediate: true})
</script>

<template>
  <div class="c-w-panels">
    <CustomPanel
        :icon="PieChart02"
        :number="info.errors.total"
        type="error"
        label="All errors"
        @click="errorStore.selectPanel('allErrors')"
        :is-active="errorStore.panels.allErrors"
    />
    <CustomPanel
        :icon="Trash01"
        :number="info.errors.reply_time"
        type="error"
        label="Reply time"
        @click="errorStore.selectPanel('replyTime')"
        :is-active="errorStore.panels.replyTime"
    />
    <CustomPanel
        :icon="Edit02"
        :number="info.errors.unanswered"
        type="error"
        label="Unanswered"
        @click="errorStore.selectPanel('unanswered')"
        :is-active="errorStore.panels.unanswered"
    />
    <CustomPanel
        :icon="Clock"
        :number="info.errors.deleted"
        type="error"
        label="Deleted"
        @click="errorStore.selectPanel('deleted')"
        :is-active="errorStore.panels.deleted"
    />
    <CustomPanel
        :icon="PhoneHangUp"
        :number="info.errors.edited"
        type="error"
        label="Edited"
        @click="errorStore.selectPanel('edited')"
        :is-active="errorStore.panels.edited"
    />
  </div>
</template>

<style lang="scss" scoped>
.c-w-panels {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid var(--color-border);

  .column {
    width: 100%;
  }
}
</style>
